<script setup lang="ts">
defineProps<{
  label?: string;
}>();
</script>

<template>
  <div class="text-grey m-5 p-5 text-center d-flex flex-column gap-3">
    <i class="bi bi-wifi-off h1"></i>
    <span v-if="label" class="h5"> {{ label }} </span>
  </div>
</template>

<style lang="scss" scoped></style>
